// import React, { Component } from "react";

// // reactstrap components
// import {
//   Card,
//   CardBody,
//   CardHeader,
//   CardTitle,
//   Row,
//   Input,
//   Col,
//   Button,
//   Alert,
// } from "reactstrap";
// import axios from "axios";
// import { Navigate, withRouter } from "react-router-dom";
// import Vimeo from "@u-wave/react-vimeo";
// import NotificationAlert from "react-notification-alert";
// import API, { base } from "api.js";
// import { Player, BigPlayButton } from "video-react";
// import ReactPlayer from "react-player";
// import cookie from "react-cookies";
// // core components
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
// import { store, persistor } from "store/index";
// import Unauthorized from "views/Unauthorized.jsx";

// import UserIcon from "assets/images/images_new/user-icon.svg";
// import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
// import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

// class ShowVideo extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       videoData: [],
//       currentQuestion: 1,
//       isRecording: false,
//       blobURL: "",
//       isBlocked: false,
//       type: "",
//       comment: "",
//       error: false,
//       userId: null,
//       commentData: [],
//       loadMore: false,
//     };
//   }

//   componentDidMount() {
//     API({
//       method: "GET",
//       url: `stgy-video/${this.props.params?.id}`,
//     })
//       .then((data) => {
//         if (data.status === 208) {
//           this.props.history.push("/admin/unauthorized");
//         } else if (data.status === 200) {
//           console.log(data.data.data);
//           let loadMore = true;
//           if (data.data.data.comment.length < 10) {
//             loadMore = false;
//           }

//           if (data.status === 200) {
//             this.setState({
//               videoData: data.data.data,
//               commentData: data.data.data.comment,
//               loadMore: loadMore,
//             });
//           }

//           API({
//             method: "GET",
//             url: "user-data-get/id",
//           })
//             .then((data) => {
//               let userId = data.data.user.id;
//               this.setState({ userId: userId });
//             })
//             .catch(() => {});
//         }
//       })
//       .catch(() => {});
//   }

//   loadMoreComment = () => {
//     API({
//       method: "GET",
//       url:
//         "videoComment/" +
//         this.props.match.params.id +
//         "?skip=" +
//         this.state.commentData.length,
//     })
//       .then((data) => {
//         let loadMore = true;
//         if (data.data.length < 10) {
//           loadMore = false;
//         }
//         this.setState({
//           commentData: [...this.state.commentData, ...data.data],
//           loadMore,
//         });
//       })
//       .catch(() => {});
//   };

//   changeComment = (e) => {
//     let { name, value } = e.target;
//     this.setState({ [name]: value });
//   };

//   addComent = async () => {
//     if (this.state.comment !== "") {
//       let bodyFormData = new FormData();
//       bodyFormData.set("comment", this.state.comment);
//       bodyFormData.set("video_id", this.props.match.params.id);

//       let res = null;
//       try {
//         res = await API({
//           method: "POST",
//           url: "add/comment-stgy",
//           data: bodyFormData,
//         });
//       } catch (error) {}

//       if (res) {
//         if (res.status === 200) {
//           this.setState({
//             commentData: res.data.data.comment,
//             comment: "",
//           });
//           this.notify(1, res.data.message);
//         }
//       }
//     } else {
//       this.notify(2, "Comment can't be empty.");
//     }
//   };

//   notify = (type, message) => {
//     switch (type) {
//       case 1:
//         type = "success";
//         break;
//       case 2:
//         type = "danger";
//         break;
//       default:
//         break;
//     }
//     var options = {};
//     options = {
//       place: "br",
//       message: (
//         <div>
//           <div>{message}</div>
//         </div>
//       ),
//       type: type,
//       autoDismiss: 5,
//       closeButton: false,
//     };
//     this.refs.notificationAlert.notificationAlert(options);
//   };

//   deleteComment = async (e, id) => {
//     var bodyFormData = {
//       id,
//       video_id: this.props.match.params.id,
//     };

//     let res = null;
//     try {
//       res = await API({
//         method: "Delete",
//         url: "delete/comment-stgy",
//         data: bodyFormData,
//       });
//     } catch (error) {}

//     if (res) {
//       if (res.status === 200) {
//         this.notify(1, res.data.message);
//         this.setState({ commentData: res.data.data.comment });
//       }
//     }
//   };

//   comment = () => {
//     this.forceUpdate();
//   };

//   userImage = (image) => {
//     let user_image = UserIcon;
//     if (image) {
//       user_image = `${base}${image}`;
//     }
//     return user_image;
//   };

//   render() {
//     const { commentData, videoData, comment, loadMore } = this.state;

//     return (
//       <div className="content p-0 w-100">
//         <div className="notification-div">
//           <NotificationAlert ref="notificationAlert" zIndex={9999} />
//         </div>

//         <DashboardHeader title={videoData?.title} />
//         <div className="videos-comment-page outer-wrapper">
//           <div className="video-comment-card">
//             <div className="video-comment-wrapper">
//               <ReactPlayer
//                 url={videoData?.link}
//                 vimeo="true"
//                 className="comment-video"
//                 controls
//               />
//             </div>
//             <div className="video-comment-content">
//               <h2>PTE SPEAKING MASTERCLASS WITH UPDATED STRATEGIES</h2>
//               <p>PTE Speaking Masterclass with Updated Strategies</p>
//             </div>
//           </div>
//           <div className="videos-comment-content">
//             <textarea
//               // type="text"
//               className="form-control"
//               placeholder="Add a comment..."
//               name="comment"
//               value={comment}
//               onChange={(e) => this.changeComment(e)}
//             ></textarea>

//             <button
//               type="button"
//               className="comment-btn"
//               onClick={this.addComent}
//             >
//               Comment
//             </button>

//             <div className="comment-content">
//               <h2 className="comment-title">
//                 Comments{" "}
//                 <a href="#" className="comment-number">
//                   ({commentData.length} of {videoData.total_comments})
//                 </a>
//               </h2>
//               <div className="comment-info">
//                 {commentData.map((val, key) => {
//                   if (val.user !== null) {
//                     return (
//                       <div className="user-info" key={key}>
//                         <div className="user-row">
//                           <div className="user-img">
//                             <img
//                               src={this.userImage(val.user.image)}
//                               alt="-"
//                               style={{
//                                 width: "25px",
//                               }}
//                             />
//                           </div>
//                           <div className="user-name">{val.user.first_name}</div>
//                           <div className="comment-date">
//                             {val.aus_date}(AEDT)
//                           </div>
//                         </div>
//                         <p className="user-comment">{val.comment}</p>
//                         {val.user_id === this.state.userId && (
//                           <p className="user-comment">
//                             <button
//                               type="button"
//                               className="outline-btn"
//                               onClick={(e) => this.deleteComment(e, val.id)}
//                             >
//                               Delete Comment
//                             </button>
//                           </p>
//                         )}
//                       </div>
//                     );
//                   }
//                 })}

//                 {loadMore && (
//                   <button
//                     className="outline-btn mt-4"
//                     onClick={(e) => {
//                       this.loadMoreComment();
//                     }}
//                   >
//                     Load More
//                   </button>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default ShowVideo;

import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Input,
  Col,
  Button,
  Alert,
} from "reactstrap";
import axios from "axios";
import Vimeo from "@u-wave/react-vimeo";
// import NotificationAlert from "react-notification-alert";
import API, { base } from "api.js";
import { Player, BigPlayButton } from "video-react";
import ReactPlayer from "react-player";
import cookie from "react-cookies";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { store, persistor } from "store/index";
import Unauthorized from "views/Unauthorized.jsx";

import UserIcon from "assets/images/images_new/user-icon.svg";
import ArrowIcon from "assets/images/images_new/dropdown-icon.svg";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";

const ShowVideo = () => {
  const params = useParams();
  const navigate = useNavigate();
  // const notificationAlertRef = useRef();

  const [videoData, setVideoData] = useState();
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [type, setType] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [userId, setUserId] = useState(null);
  const [commentData, setCommentData] = useState([]);
  const [loadMore, setLoadMore] = useState(false);

  useEffect(() => {
    API({
      method: "GET",
      url: `video/${params?.id}`,
    })
      .then((data) => {
        if (data.status === 208) {
          navigate("/admin/unauthorized");
        } else if (data.status === 200) {
          console.log(data);
          let loadMoreFlag = true;
          if (data.data.comment.length < 10) {
            loadMoreFlag = false;
          }

          if (data.status === 200) {
            console.log(data);
            
            setVideoData(data.data);
            setCommentData(data.data.data.comment);
            setLoadMore(loadMoreFlag);
          }

          API({
            method: "GET",
            url: "user-data-get/id",
          })
            .then((data) => {
              let userIdValue = data.data.user.id;
              setUserId(userIdValue);
            })
            .catch(() => { });
        }
      })
      .catch(() => { });
  }, [params?.id, navigate]);

  const loadMoreComment = () => {
    API({
      method: "GET",
      url: "videoComment/" + params.id + "?skip=" + commentData.length,
    })
      .then((data) => {
        let loadMoreFlag = true;
        if (data.data.length < 10) {
          loadMoreFlag = false;
        }
        setCommentData([...commentData, ...data.data]);
        setLoadMore(loadMoreFlag);
      })
      .catch(() => { });
  };

  const changeComment = (e) => {
    let { name, value } = e.target;
    if (name === "comment") {
      setComment(value);
    }
  };

  const addComent = async () => {
    if (comment !== "") {
      let bodyFormData = new FormData();
      bodyFormData.set("comment", comment);
      bodyFormData.set("video_id", params.id);

      let res = null;
      try {
        res = await API({
          method: "POST",
          url: "add/comment-stgy",
          data: bodyFormData,
        });
      } catch (error) { }

      if (res) {
        if (res.status === 200) {
          setCommentData(res.data.data.comment);
          setComment("");
          notify(1, res.data.message);
        }
      }
    } else {
      notify(2, "Comment can't be empty.");
    }
  };

  const notify = (type, message) => {
    switch (type) {
      case 1:
        type = "success";
        break;
      case 2:
        type = "danger";
        break;
      default:
        break;
    }
    var options = {};
    options = {
      place: "br",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      autoDismiss: 5,
      closeButton: false,
    };
    // notificationAlertRef.current.notificationAlert(options);
  };

  const deleteComment = async (e, id) => {
    var bodyFormData = {
      id,
      video_id: params.id,
    };

    let res = null;
    try {
      res = await API({
        method: "Delete",
        url: "delete/comment-stgy",
        data: bodyFormData,
      });
    } catch (error) { }

    if (res) {
      if (res.status === 200) {
        notify(1, res.data.message);
        setCommentData(res.data.data.comment);
      }
    }
  };

  const userImage = (image) => {
    let user_image = UserIcon;
    if (image) {
      user_image = `${base}${image}`;
    }
    return user_image;
  };

  console.log("videoData==", videoData);
  
const convertToPlayerUrl = (link) => {
  if (!link) return "";
  try {
    // Remove HTML entities if present
    console.log(link);
    
    const cleanLink = link.replace(/&/g, '&');
    const url = new URL(cleanLink);
    const pathParts = url.pathname.split("/").filter(Boolean);
    const videoId = pathParts[0]; // "1106963843"
    const hash = pathParts[1]; // "df2e24eece"
    
    return `https://player.vimeo.com/video/${videoId}?h=${hash}`;
  } catch (err) {
    return link;
  }
};

  return (
    <div className="content p-0 w-100">
      {/* <div className="notification-div">
        <NotificationAlert ref={notificationAlertRef} zIndex={9999} />
      </div> */}

      <DashboardHeader title={videoData?.title} />
      <div className="videos-comment-page outer-wrapper">
        <div className="video-comment-card">
          <div className="video-comment-wrapper">
            {/* <ReactPlayer
              url={videoData?.link}
              vimeo="true"
              className="comment-video"
              controls
            /> */}
            <ReactPlayer
              url={convertToPlayerUrl(videoData?.link)}
              className="comment-video"
              controls
            />
          </div>
          <div className="video-comment-content">
            <h2>PTE SPEAKING MASTERCLASS WITH UPDATED STRATEGIES</h2>
            <p>PTE Speaking Masterclass with Updated Strategies</p>
          </div>
        </div>
        {/* <div className="videos-comment-content">
          <textarea
            // type="text"
            className="form-control"
            placeholder="Add a comment..."
            name="comment"
            value={comment}
            onChange={(e) => changeComment(e)}
          ></textarea>

          <button type="button" className="comment-btn" onClick={addComent}>
            Comment
          </button>

          <div className="comment-content">
            <h2 className="comment-title">
              Comments{" "}
              <a href="#" className="comment-number">
                ({commentData.length} of {videoData.total_comments})
              </a>
            </h2>
            <div className="comment-info">
              {commentData.map((val, key) => {
                if (val.user !== null) {
                  return (
                    <div className="user-info" key={key}>
                      <div className="user-row">
                        <div className="user-img">
                          <img
                            src={userImage(val.user.image)}
                            alt="-"
                            style={{
                              width: "25px",
                            }}
                          />
                        </div>
                        <div className="user-name">{val.user.first_name}</div>
                        <div className="comment-date">
                          {val.aus_date}(AEDT)
                        </div>
                      </div>
                      <p className="user-comment">{val.comment}</p>
                      {val.user_id === userId && (
                        <p className="user-comment">
                          <button
                            type="button"
                            className="outline-btn"
                            onClick={(e) => deleteComment(e, val.id)}
                          >
                            Delete Comment
                          </button>
                        </p>
                      )}
                    </div>
                  );
                }
              })}

              {loadMore && (
                <button
                  className="outline-btn mt-4"
                  onClick={(e) => {
                    loadMoreComment();
                  }}
                >
                  Load More
                </button>
              )}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default ShowVideo;